/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

// useDebouncedDispatch.ts
import { useAppDispatch } from 'helpers/store'
import { useDebouncedCallback } from 'utils/hooks/useDebounce'

export const useDebouncedDispatch = () => {
    const dispatch = useAppDispatch()

    // Debounce dispatch to delay execution until 200ms have passed since last invocation
    const debouncedDispatch = useDebouncedCallback(
        (action: any) => dispatch(action),
        200
    )

    return {
        debouncedDispatch,
    }
}
